import { render } from "./AddAccountContactForm.vue?vue&type=template&id=021141f4"
import script from "./AddAccountContactForm.vue?vue&type=script&lang=js"
export * from "./AddAccountContactForm.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__